<template>
      
</template>


<script>
export default {
    name: "App",
  data() {
    return{
        status:0,
    }
    

  },
  methods: {


  },
  mounted(){
    //this.$router.push('/promocion');
    let me = this;
    console.log("Cerrando sessión");
    console.log("Usuario activo: "+me.usuario);
    if(me.usuario == null){
      this.$router.push('/');
      location.reload();
    }

  }
}
 
</script>